import { gql } from 'react-apollo';

export default gql`
  query tickets($page: Int, $per_page: Int, $order: String, $order_by: String) {
    tickets(
      page: $page
      per_page: $per_page
      order: $order
      order_by: $order_by
    ) {
      count
      pages
      tickets {
        type
        ticket_id
        created_at
        status
        year
        user {
          user_id
          first_name
          last_name
        }
        purchaser {
          user_id
          first_name
          last_name
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graph/queryTickets.js